import React, { Fragment } from "react"
import Media from "react-media"
import { Link, qraphql } from "gatsby"
import { Carousel } from "react-bootstrap"
import Img from "gatsby-image"
import { Container, Row, Col } from "reactstrap"
import Layout from "../components/layout"
import { FaRocket, FaCheckDouble, FaQuestionCircle } from "react-icons/fa"
import SEO from "../components/seo"
import "bootstrap/dist/css/bootstrap.min.css"
import "../style/bootstrap.css"
import "../style/index.css"

function IndexPage(props) {
  // const [width, setWidth] = React.useState(window.innerWidth)
  // const breakpoint = 575.98

  // React.useEffect(() => {
  // const handleWindowResize = () => setWidth(window.innerWidth)
  /* Inside of a "useEffect" hook add an event listener that updates
       the "width" state variable when the window size changes */
  // window.addEventListener("resize", () => setWidth(window.innerWidth))
  // Return a function from the effect that removes the event listener
  // return () => window.removeEventListener("resize", handleWindowResize)
  /* passing an empty array as the dependencies of the effect will cause this
       effect to only run when the component mounts, and not each time it updates.
       We only want the listener to be added once */
  // }, [])

  // const getCarouselCaption = (title, description, route, className) => {
  //   if (width <= breakpoint) {
  //     return (
  //       <div className="carousel-caption" id={"carousel-caption-" + className}>
  //         <Link className="carousel-caption-links" to={"/" + route}>
  //           <span className="carousel-caption-title">{title}</span>
  //         </Link>
  //       </div>
  //     )
  //   } else {
  //     return (
  //       <div className="carousel-caption" id={"carousel-caption-" + className}>
  //         <Link className="carousel-caption-links" to={"/" + route}>
  //           <span className="carousel-caption-title">{title}</span> -{" "}
  //           {description}
  //         </Link>
  //       </div>
  //     )
  //   }
  // }

  return (
    <Layout>
      <SEO title="Home" />
      {/* Uncomment for spacing around the carousel */}
      {/* <div id="carousel"> */}
      <Carousel indicators={true} style={{ backgroundColor: "#454851" }}>
        <Carousel.Item>
          <Img
            className="carousel-images"
            fluid={props.data.replication.childImageSharp.fluid}
            alt="Replication"
          />
          <div className="carousel-caption" id={"carousel-caption-replication"}>
            <Link className="carousel-caption-links" to={"/replication"}>
              <span className="carousel-caption-title">Replication</span>
              <Media
                queries={{
                  // small: "(max-width: 575.98px)",
                  medium: "(min-width: 575.99px)",
                }}
              >
                {matches => (
                  <Fragment>
                    {matches.medium &&
                      " - Capture immovable mountains of data to Relational streams and Big Data lakes"}
                  </Fragment>
                )}
              </Media>
            </Link>
          </div>
          {/* {getCarouselCaption(
            "Replication",
            " - Capture immovable mountains of data to Relational streams and Big Data lakes",
            "replication",
            "replication"
          )} */}
        </Carousel.Item>
        <Carousel.Item>
          <Img
            className="carousel-images"
            fluid={props.data.mirroring.childImageSharp.fluid}
            alt="Mirroring"
          />
          <div className="carousel-caption" id={"carousel-caption-mirroring"}>
            <Link className="carousel-caption-links" to={"/mirroring"}>
              <span className="carousel-caption-title">Mirroring</span>
              <Media
                queries={{
                  // small: "(max-width: 575.98px)",
                  medium: "(min-width: 575.99px)",
                }}
              >
                {matches => (
                  <Fragment>
                    {matches.medium &&
                      " - Take mainframe IDMS through the looking glass, without breaking it"}
                  </Fragment>
                )}
              </Media>
            </Link>
          </div>
          {/* {getCarouselCaption(
            "Mirroring",
            "Take mainframe IDMS through the looking glass, without breaking it",
            "mirroring",
            "mirroring"
          )} */}
        </Carousel.Item>
        <Carousel.Item>
          <Img
            className="carousel-images"
            fluid={props.data.performance.childImageSharp.fluid}
            alt="Performance Analysis"
          />
          <div className="carousel-caption" id={"carousel-caption-performance"}>
            <Link className="carousel-caption-links" to={"/monitoring"}>
              <span className="carousel-caption-title">
                Performance Analysis
              </span>
              <Media
                queries={{
                  // small: "(max-width: 575.98px)",
                  medium: "(min-width: 575.99px)",
                }}
              >
                {matches => (
                  <Fragment>
                    {matches.medium &&
                      " - Get the big picture on mainframe activity, for whatever you're up to"}
                  </Fragment>
                )}
              </Media>
            </Link>
          </div>
          {/* {getCarouselCaption(
            "Performance Analysis",
            "Get the big picture on mainframe activity, for whatever you're up to",
            "monitoring",
            "performance"
          )} */}
        </Carousel.Item>
        <Carousel.Item>
          <Img
            className="carousel-images"
            fluid={props.data.consulting.childImageSharp.fluid}
            alt="Consulting"
          />
          <div className="carousel-caption" id={"carousel-caption-consulting"}>
            <Link className="carousel-caption-links" to={"/consulting"}>
              <span className="carousel-caption-title">Consulting</span>
              <Media
                queries={{
                  // small: "(max-width: 575.98px)",
                  medium: "(min-width: 575.99px)",
                }}
              >
                {matches => (
                  <Fragment>
                    {matches.medium &&
                      " - Extensive knowledge and experience to help connect old with new, and solve unique problems"}
                  </Fragment>
                )}
              </Media>
            </Link>
          </div>
          {/* {getCarouselCaption(
            "Consulting",
            "Extensive knowledge and experience to help connect old with new, and solve unique problems",
            "consulting",
            "consulting"
          )} */}
        </Carousel.Item>
      </Carousel>
      {/* </div> */}
      <Container>
        <Row className="MainframeAndMore-row">
          <Col>
            <h1 id="main-heading">Mainframe & More</h1>
          </Col>
        </Row>
        <Row>
          <Col
            className="my-auto"
            xs="12"
            sm="6"
            style={{ textAlign: "center" }}
          >
            <FaRocket className="icons" />
          </Col>
          <Col xs="12" sm="6">
            <h2 style={{ textAlign: "center" }}>Performance</h2>
            <p style={{ textAlign: "justify" }}>
              Suffixes matter; why settle for performant when there's more
              performance to be had? ISP focuses on continual optimization,
              flexibility and resource reduction
            </p>
          </Col>
        </Row>
        <Row className="rows">
          <Col
            className="my-auto"
            xs="12"
            sm={{ size: "6", order: "2" }}
            style={{ textAlign: "center" }}
          >
            <FaCheckDouble className="icons" />
          </Col>
          <Col xs="12" sm={{ size: "6", order: "1" }}>
            <h2 style={{ textAlign: "center" }}>Reliability</h2>
            <p style={{ textAlign: "justify" }}>
              From one-off archiving to large, mission-critical applications
              that need to run for months or years, ISP's products are designed
              to just work, while offering proven recovery methods in case of...
              whatever happens
            </p>
          </Col>
        </Row>
        <Row className="rows">
          <Col
            className="my-auto"
            xs="12"
            sm="6"
            style={{ textAlign: "center" }}
          >
            <FaQuestionCircle className="icons" />
          </Col>
          <Col xs="12" sm="6">
            <h2 style={{ textAlign: "center" }}>Service & Support</h2>
            <p style={{ textAlign: "justify" }}>
              ISP provides 24/7 support on all products offered. We strive to
              help you address your site's unique problems with unique
              solutions, without breaking molds or the banks. Fair pricing and
              fair contracts are standard
            </p>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default IndexPage

export const query = graphql`
  query {
    replication: file(relativePath: { eq: "mountains.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    mirroring: file(relativePath: { eq: "mirroring.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    performance: file(relativePath: { eq: "performance_monitoring.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    consulting: file(relativePath: { eq: "consulting.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
